import { CSSProperties } from 'react';

interface ChatImageProps {
    uri: string;
    href?: string;
}

const styles: Record<string, CSSProperties> = {
    container: {
        minWidth: '250px',
        display: 'flex',
        overflow: 'hidden'
    },
    image: {
        flex: '1',
        width: '100%',
        height: '250px',
        objectFit: 'cover'
    }
};

export default function ChatImage({ uri, href }: ChatImageProps) {
    return (
        <a
            className="gsocial-chat-list__image-link"
            style={styles.container}
            href={href || uri}
            target="_blank"
            rel="noreferrer"
        >
            <img className="gsocial-chat-list__image" src={uri} style={styles.image} />
        </a>
    );
}
